import { ProductsContent } from "@/components/products-content"

export default function ProductsPage() {
    return <ProductsContent />
}
